import React from "react";
import LoadQuizInp from "./LoadQuizInp";
import { useSelector } from "react-redux";
import { moodleModel } from "../../../../entities/Moodle";
import QuizItem from "./QuizItem";

interface Props {
  courseId: string;
  setCourseId: any;
}

const MoodleQuizList = ({ courseId, setCourseId }: Props) => {
  const courseBlocks = useSelector(moodleModel.selectCourseBlocks) as any[];

  console.log("quizzes", courseBlocks);

  return (
    <div>
      <LoadQuizInp courseId={courseId} setCourseId={setCourseId} />
      <div style={{ marginLeft: 30, marginBottom: 50 }}>
        <div style={{ marginTop: 20, fontWeight: 700, fontSize: 16 }}>
          Курсы
        </div>
        {courseBlocks.map((block) => {
          if (block?.content) {
            return (
              <div
                style={{
                  marginTop: 20,
                  backgroundColor: "white",
                  padding: 15,
                  borderRadius: 15,
                }}
                key={block.coursemodule}
              >
                <div dangerouslySetInnerHTML={{ __html: block?.intro }} />
                <div dangerouslySetInnerHTML={{ __html: block?.content }} />
              </div>
            );
          }
          return <QuizItem key={block.coursemodule} quiz={block} />;
        })}
      </div>
    </div>
  );
};

export default MoodleQuizList;
